<template>
  <div class="repair-process">
    <warehouse-management
      :machine="machineInfo"
      :meta="meta"
      @updateMachineInfo="updateMachineInfo"
      @updateProcess="updateProcess"
      @back="back"
      ref="warehousemanagementRef"
      v-if="meta['/warehousemanagementlook']"
    ></warehouse-management>

    <after-sale-qeustion-vue :machine="machineInfo"> </after-sale-qeustion-vue>

    <problem-confirm
      :progress="process[1]"
      :machine="machineInfo"
      :meta="meta"
      @updateMachineInfo="updateMachineInfo"
      @updateProcess="updateProcess"
      @resetProcess="resetProcess"
      @back="back"
      ref="problemconfirmRef"
      v-if="meta['/qualityinspectionlook']"
    ></problem-confirm>

    <technology
      :progress="process[2]"
      :machine="machineInfo"
      :meta="meta"
      @updateMachineInfo="updateMachineInfo"
      @updateProcess="updateProcess"
      @resetProcess="resetProcess"
      @back="back"
      ref="technologyRef"
      v-if="meta['/technologylook']"
    ></technology>

    <maintenance-machine
      :progress="process[3]"
      :machine="machineInfo"
      :meta="meta"
      @updateMachineInfo="updateMachineInfo"
      @updateProcess="updateProcess"
      @resetProcess="resetProcess"
      @back="back"
      ref="maintenancemachineRef"
      v-if="meta['/producelook']"
    ></maintenance-machine>

    <closed-cycle
      :progress="process[4]"
      :machine="machineInfo"
      :meta="meta"
      @updateMachineInfo="updateMachineInfo"
      @updateProcess="updateProcess"
      @resetProcess="resetProcess"
      @back="back"
      ref="closedcycleRef"
      v-if="meta['/technologylook']"
    ></closed-cycle>

    <final-audit-vue
      :meta="meta"
      :progress="process[5]"
      :machine="machineInfo"
      :rollBackId="process[4].id"
      @updateMachineInfo="updateMachineInfo"
      @updateProcess="updateProcess"
      @back="back"
      ref="finalauditRef"
    >
    </final-audit-vue>
  </div>
</template>

<script>
import {
  computed,
  defineComponent,
  nextTick,
  onMounted,
  reactive,
  ref,
  watch,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { getRepairProcess, getOneRepairEquipment } from "@/request/view/repair";
import { Toast } from "@/utils";
import uploadImg from "@/views/repairprogress/compoments/uploadImg.vue";
import uploadVideo from "@/views/repairprogress/compoments/uploadVideo.vue";
import warehouseManagement from "@/views/repairprogress/compoments/warehouseManagement.vue";
import technology from "@/views/repairprogress/compoments/technology.vue";
import problemConfirm from "@/views/repairprogress/compoments/problemConfirm.vue";
import maintenanceMachine from "@/views/repairprogress/compoments/maintenanceMachine.vue";
import closedCycle from "@/views/repairprogress/compoments/closedCycle.vue";
import finalAuditVue from "./compoments/finalAudit.vue";
import afterSaleQeustionVue from "./compoments/afterSaleQuestion.vue";
import { useStore } from "vuex";

export default defineComponent({
  name: "machineRepairProcess",
  components: {
    uploadImg,
    uploadVideo,
    warehouseManagement,
    problemConfirm,
    technology,
    maintenanceMachine,
    closedCycle,
    finalAuditVue,
    afterSaleQeustionVue,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    let meta = reactive({});
    const machineInfo = reactive({
      id: null,
      type: null,
      semiFinishedProducts: null,
      componentsAndParts: null,
      attribute: null,
      returnDate: null,
      replaceSerial: null,
      newCode: null,
      afterSaleProblemDescription: null,
      picture: null,
      video: null,
      serial: null,
      contactPerson: null,
    });

    const warehousemanagementRef = ref();
    const problemconfirmRef = ref();
    const technologyRef = ref();
    const maintenancemachineRef = ref();
    const closedcycleRef = ref();
    const finalauditRef = ref();

    const process = reactive({
      // 客户问题
      1: {
        type: null,
        rollbackReason: null,
        repairEquipmentId: null,
        principal: null,
        id: null,
        finishedProductProblem: null,
        completeDate: null,
        afterSaleConfirm: false,
        userId: null,
        username: null,
      },
      // 根本原因分析
      2: {
        annex: null,
        completeDate: null,
        id: null,
        isEditable: true,
        maintenancePlan: null,
        principal: null,
        repairEquipmentId: null,
        rollbackReason: null,
        type: null,
        userId: null,
        username: null,
      },
      // 机器维修
      3: {
        annex: null,
        calibrateDate: null,
        calibrateDesc: null,
        calibrateRepair: null,
        calibrateSign: null,
        completeDate: null,
        gzHost: null,
        completeReferenceArmPencil: null,
        instrumentCalibrate: null,
        completeReferenceArmDate: null,
        completeReferenceArmDesc: null,
        completeReferenceArmRepair: null,
        completeReferenceArmSign: null,
        debugLevel: null,
        detector: null,
        girdling: null,
        host: null,
        id: null,
        isEditable: null,
        isReferenceArmQualified: null,
        measured25Mid: null,
        measured25Tail: null,
        networkCable: null,
        opticalFiber: null,
        polarization: null,
        principal: null,
        referenceArmDate: null,
        referenceArmDesc: null,
        referenceArmMakeDate: null,
        referenceArmRepair: null,
        referenceArmRetestDate: null,
        referenceArmSign: null,
        repairEquipmentId: null,
        rollbackReason: null,
        screen: null,
        smaCable: null,
        solution: null,
        theory25Mid: null,
        threeMajorItemsDate: null,
        threeMajorItemsDesc: null,
        threeMajorItemsPencil: null,
        threeMajorItemsRepair: null,
        threeMajorItemsSign: null,
        completeReferenceArmNet: null,
        type: null,
        userId: null,
        username: null,
      },
      // 闭环措施
      4: {
        annex: null,
        closedLoopRollbackReason: null,
        completeDate: null,
        id: null,
        isEditable: true,
        principal: null,
        repairEquipmentId: null,
        reviewRollbackReason: null,
        rootCauseAnalyses: null,
        type: null,
        userId: null,
        username: null,
      },
      5: {
        id: null,
        repairEquipmentId: null,
        type: null,
        processRecords: null,
        completeDate: null,
        principal: null,
        attachment: null,
        rollbackReason: null,
        isEditable: false,
      },
    });
    // 给过程赋值
    const setProgressData = (data) => {
      const current = process[data.type];
      if (current) {
        Object.keys(current).forEach((key) => {
          current[key] = data[key];
        });
      }
    };
    // 获取返修过程
    const getRepairProgress = () => {
      getRepairProcess({
        id: machineInfo.id,
      })
        .then((res) => {
          if (
            res.code === 200 &&
            res.message === "成功" &&
            Object.keys(res.data).length > 0
          ) {
            Object.keys(res.data).forEach((key, index) => {
              if (res.data[key]) {
                setProgressData(res.data[key]);
              } else {
                Object.keys(process[index + 1]).forEach((processkey) => {
                  process[index + 1][processkey] = null;
                });
              }
            });
            if (res.data[4]) {
              process[5].rollbackReason = res.data[4].reviewRollbackReason;
            }
            console.log(process, '里面的数据是什么')
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    const setMeta = (val) => {
      Object.keys(meta).forEach((key) => {
        meta[key] = false;
      });
      const metaObj = JSON.parse(decodeURI(val));
      Object.keys(metaObj).forEach((key) => {
        meta[key] = metaObj[key];
      });
    };

    const updateMachineInfo = () => {
      getOneRepairEquipment({
        id: machineInfo.id,
      }).then((res) => {
        if (res.code === 200 && res.message === "成功") {
          if (res.data === null) {
            return Toast("success", "流程完成", 3);
          }
          // machineInfo.id = res.data.machineId;
          machineInfo.type = res.data.serialType;
          machineInfo.attribute = res.data.attribute;
          machineInfo.componentsAndParts = res.data.componentsAndParts;
          machineInfo.semiFinishedProducts = res.data.semiFinishedProducts;
          machineInfo.returnDate = res.data.returnDate;
          machineInfo.replaceSerial = res.data.replaceSerial;
          machineInfo.newCode = res.data.newCode;
          machineInfo.repairProcess = res.data.repairProcess;
          machineInfo.principal = res.data.principal;
        }
      });
    };

    const resetProcess = () => {
      getRepairProgress();
    };

    const updateProcess = (data) => {
      process[data.type].id = data.id;
    };

    const setBarscroll = (repairProcess) => {
      const repairProcessTarget = {
        0: warehousemanagementRef,
        1: problemconfirmRef,
        2: technologyRef,
        3: maintenancemachineRef,
        4: closedcycleRef,
        5: finalauditRef,
      };
      const target = repairProcessTarget[Number(repairProcess)];

      if (target && target.value && Number(repairProcess) !== 0) {
        target.value.$el.nextElementSibling.scrollIntoView();
      }
    };

    const back = () => {
      const path = store.state.isMonile ? "/repair" : "/repairequipment";
      router.replace(path);
    };

    watch(
      () => route,
      (val) => {
        // machineId.value = val.query.machineId;
        if (route.path === "/repairprogress") {
          machineInfo.id = val.query.machineId;
          machineInfo.type = val.query.type;
          machineInfo.attribute = val.query.attribute;
          machineInfo.componentsAndParts = val.query.componentsAndParts;
          machineInfo.semiFinishedProducts = val.query.semiFinishedProducts;
          machineInfo.returnDate = val.query.returnDate;
          machineInfo.replaceSerial = val.query.replaceSerial;
          machineInfo.newCode = val.query.newCode;
          machineInfo.repairProcess = val.query.repairProcess;
          machineInfo.principal = val.query.principal;
          machineInfo.completeDate = val.query.completeDate;
          machineInfo.auditTime = val.query.auditTime;
          machineInfo.username = val.query.username;
          machineInfo.userId = val.query.userId;
          machineInfo.afterSaleProblemDescription =
            val.query.afterSaleProblemDescription;
          machineInfo.picture = val.query.picture;
          machineInfo.video = val.query.video;
          machineInfo.serial = val.query.serial;
          machineInfo.contactPerson = val.query.contactPerson;
          setMeta(val.query.meta);
          getRepairProgress();
          nextTick(() => {
            setBarscroll(machineInfo.repairProcess);
          });
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );
    return {
      uploadImg,
      process,
      machineInfo,
      meta,
      updateMachineInfo,
      updateProcess,
      resetProcess,
      back,
      warehousemanagementRef,
      problemconfirmRef,
      technologyRef,
      maintenancemachineRef,
      closedcycleRef,
      finalauditRef,
    };
  },
});
</script>

<style lang="less">
.repair-process {
  background: #f9f9f9;
  padding: 20px;
  overflow: scroll;
  width: 100vw;
  height: 100vh;
}
.repair-step {
  width: 1400px;
  margin: 0 auto;
  padding: 0 24px 24px;
  margin-bottom: 20px;
  background: #ffffff;
  box-shadow: 3px 3px 8px 4px rgba(8, 26, 81, 0.04),
    0px 2px 4px -1px rgba(8, 26, 81, 0.08);
  border-radius: 10px;
  .title {
    height: 67px;
    font-size: 20px;
    color: #333333;
    line-height: 67px;
    border-bottom: 1px solid #d8d8d8;
    font-weight: bold;
  }
  .checkbox-select {
    margin-top: 20px;
  }
  .footer {
    border-top: 1px solid #d8d8d8;
    padding-top: 20px;
    margin-top: 20px;
  }
  .step-label {
    font-size: 16px;
    color: #282e34;
    width: 110px;
    text-align: right;
    margin-right: 10px;
  }
  .label-space {
    margin-right: 100px;
  }
  .item-space {
    margin-top: 16px;
  }
  .form {
    padding-top: 20px;
    .form-item {
      display: flex;
      margin-bottom: 16px;
      .label {
        font-size: 16px;
        font-weight: bold;
        color: #282e34;
        margin-right: 10px;
      }
      .data {
        font-size: 16px;
      }
      .input-data {
        width: 308px;
      }
      .upload-data {
        width: 800px;
      }
      .text-area-data {
        width: 600px;
      }
    }
  }
}

.mobile-repair-step {
  width: auto;
  margin: none;
}

.ant-btn-dashed[disabled] {
  color: #000;
}
.ant-input[disabled] {
  color: #000;
}
</style>
